<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div id="id_copy_dist_lbl" [fxFlex]="labelFlex">
    {{ textLabel | translate }}
  </div>

  <div [fxFlex]="formWrapperFlex">
    <form [formGroup]="form">    
      <mat-form-field class="width-100">
        <input 
          matInput
          #distributionInput
          formControlName="distribution" 
          [matAutocomplete]="distributionAC" 
          (focus)="!distributionAC.isOpen && getInitialValues('distribution')" 
          >

        <mat-icon 
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="distributionInput.blur(); clearForm($event)"
          *ngIf="distributionInput.value && !isDisabled" 
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          svgIcon="menu-down" 
          class="vertical-align-middle"
          *ngIf="!distributionInput.value"
          >
        </mat-icon>

        <mat-autocomplete
          id="id_copy_dist_dropdown" 
          [displayWith]="displayFn" 
          #distributionAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); distributionInput.blur()"
          (opened)="autocompleteScroll('distribution','distributionACRef','distributionACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.distribution && listData?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_copy_dist_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code + ' - ' + data.description"
            >
            {{ data.code }} - {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.distribution" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('distribution').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: currentStep} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>